var allowedCharts = {
  Column2D: !0,
  Line: !0,
  Area2D: !0,
  Bar2D: !0,
  MSColumn2D: !0,
  MSLine: !0,
  MSBar2D: !0,
  MSArea: !0,
  StackedColumn2D: !0,
  StackedBar2D: !0,
  StackedArea2D: !0,
  MSStackedColumn2D: !0,
  MSCombi2D: !0,
  StackedColumn2DLine: !0,
  MSCombidy2D: !0,
  LogMSColumn2d: !0,
  LogMSLine: !0,
  DragColumn: !0,
  DragLine: !0,
  DragArea: !0
},
    filterType = {
  Column: 'maxOnly',
  line: 'minMax',
  area: 'minMax'
};
export { allowedCharts, filterType };